import styled from 'styled-components';

const Triangle = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: #fff;
    transform: rotate(45deg);
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
  }
`;

export default Triangle;


// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/Modal/Triangle.js